var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronDownFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 8,
  height: 5,
  fill: "none",
  viewBox: "0 0 8 5"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M3.897 4.5 7.794 0H0z"
})));
SvgChevronDownFilled.displayName = "SvgChevronDownFilled";
export { SvgChevronDownFilled as ReactComponent };
export default SvgChevronDownFilled;